<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="地址确认"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  label-width="100px">
        <el-form-item label="地址" style="color:#4C71DB">  
           {{info.address}}
        </el-form-item>

        <el-form-item label="详细地址">  
         {{info.adname}}
        </el-form-item>

        <el-form-item label="备注">
          {{info.remark}}
        </el-form-item>

      

        <el-form-item label="是否同意"  >
          <el-radio-group v-model="formData.relation_status" size="small">
            <el-radio label="10" border>同意</el-radio>
            <el-radio label="11" border>拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拒绝理由" v-if="formData.relation_status=='11'">
          <el-input 
            type="textarea" 
            v-model="formData.reason"  
            :rows="4"
            placeholder="输入拒绝原因"></el-input>
        </el-form-item>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit" >确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { jobEnrollAddressUpdate} from "@/api/personal/work/job/index.js";


export default {

  data() {
    return {
      visible: false,
      formData:{
        enroll_id: "",
        relation_status:'10',
        reason:'',

      },
      info: {
        id:"",
        enroll_id: "",
        adname: "",
        address: "",
        remark:"",
        lat: "",
        lng: "",
      },
      
    };
  },

 
  mounted() {

  },

  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init(info) {
      this.visible = true;
      this.info=info;
      this.formData.enroll_id=info.enroll_id;

    },

   /* initInfo(){
      var that = this;
      auditInfo({"enroll_id":that.formData.enroll_id}).then((response) => {
        if(response.code==200){
          that.info = response.data;

        }else{
          that.$message.warning(response.msg?response.msg:"获取信息失败");
        }
      });
    },*/

    
    submit(){
      var that=this;
      if(this.formData.relation_status==11){
        if(this.formData.reason==""){
          that.$message.warning("请输入拒绝理由");
          return;
        }

      }
      
      this.$refs["form"].validate((valid) => {
          if (valid) {
            jobEnrollAddressUpdate(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
